// Vehicle requests
export const VEHICLE_LIST = "VEHICLE_LIST";
export const VEHICLE_CREATE = "VEHICLE_CREATE";
export const VEHICLE_FILTER = "VEHICLE_FILTER";
export const VEHICLE_UPDATE = "VEHICLE_UPDATE";

// Vehicle success
export const VEHICLE_LIST_SUCCESS = "VEHICLE_LIST_SUCCESS";
export const VEHICLE_CREATE_SUCCESS = "VEHICLE_CREATE_SUCCESS";
export const VEHICLE_UPDATE_SUCCESS = "VEHICLE_UPDATE_SUCCESS";

// Vehicle failed
export const VEHICLE_REQUEST_FAILED = "VEHICLE_REQUEST_FAILED";
